import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';

const useGetAuthUrlForTeams = () => {
    const userApi = useContainer(UserApi);

    const getTeamsAuthorizeUrl = (): Promise<string> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.getTeamsIntegrationAuthorizeUrl({
                onSuccess: res => resolve(res.body.url),
                onError: error => reject(error),
            });

            exec();
        });
    };

    return { getTeamsAuthorizeUrl };
};

export default useGetAuthUrlForTeams;
